export enum CourseRelevantExecutionDisabledReasonEnum {
    RegistrationClosed = 'registration_closed',
    ExecutionPlanned = 'execution_planned',
    CourseListed = 'course_listed',
}
